// Groups the ranked suggestions from GET /api/resumes/{resume}/score under
// the sidebar's four categories. The server writes every card's label and
// message (EN-971); this only decides which section a card goes in, its dot
// color, and its list key.

export const SUGGESTION_CATEGORIES = ['alignment', 'content', 'structure', 'completeness'];

export const CATEGORY_DOT_COLOR = {
	alignment: 'bg-won-green',
	content: 'bg-won-sky-blue',
	structure: 'bg-won-purple',
	completeness: 'bg-won-orange',
};

// A suggestion's type starts with its category, e.g. `content-action-verb`.
export const categoryOf = (suggestion) => {
	const prefix = suggestion?.type?.split('-')[0];

	return SUGGESTION_CATEGORIES.includes(prefix) ? prefix : null;
};

export const groupSuggestionsByCategory = (suggestions) => {
	const groups = Object.fromEntries(SUGGESTION_CATEGORIES.map((category) => [category, []]));

	(suggestions ?? []).forEach((suggestion) => {
		const category = categoryOf(suggestion);

		if (category) {
			groups[category].push(suggestion);
		}
	});

	return groups;
};

// A card's list key: the rule it belongs to plus what it points at. Not the message, which quotes
// the bullet or entry and so changes on every edit (EN-812); missing-skill cards share an anchor,
// but each skill is its own rule.
export const suggestionKey = (suggestion) => [suggestion.reveal_key, suggestion.anchor].join('|');
